import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the messages-sent chart. */
export const MessageVolumePointSchema = z
  .object({
    bucket: z.string(),
    count: z.number().int().nonnegative(),
  })
  .strict();

export type MessageVolumePoint = z.infer<typeof MessageVolumePointSchema>;

/** The Dashboard's Engagement section, chat half (D12). */
export const ChatStatsSchema = z
  .object({
    window: StatsWindowSchema,
    messagesSent: ComparableCountSchema,
    activeConversations: z.number().int().nonnegative(),
    messagesPerBucket: z.array(MessageVolumePointSchema),
  })
  .strict();

export type ChatStats = z.infer<typeof ChatStatsSchema>;
